import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section className="py-20 md:py-28 px-4 bg-beige relative" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-highlight/50" data-id="element-134">
          <div className="bg-primary text-center py-6 px-4" data-id="element-135">
            <h2 className="text-2xl md:text-3xl font-bold text-warm font-serif" data-id="element-136">
              Resumen de tu inversión
            </h2>
          </div>

          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-137">
            <p className="text-secondary text-lg mb-2" data-id="element-138">
              El valor real de todo este contenido podría ser{' '}
              <span className="line-through decoration-red-500/50 decoration-2" data-id="element-139">
                $30.000 ARS
              </span>
            </p>

            <p className="text-primary font-medium mb-6" data-id="element-140">
              Pero hoy podés acceder por solo:
            </p>

            <ul className="text-sm text-secondary space-y-1.5 mb-6 text-left max-w-md mx-auto" data-id="element-141">
              <li data-id="element-142">🔐 Compra 100% segura con Mercado Pago</li>
              <li data-id="element-143">📩 Acceso inmediato luego del pago</li>
              <li data-id="element-144">‼️ Producto 100% digital (no se envía nada físico)</li>
              <li data-id="element-145">🧾 Los datos solicitados son solo para facturación</li>
              <li data-id="element-146">⭐️ +1.000 personas ya empezaron su transformación</li>
            </ul>

            <div className="flex items-start justify-center gap-2 mb-8" data-id="element-147">
              <span className="text-3xl font-bold text-cta mt-2" data-id="element-148">$</span>
              <span className="text-6xl md:text-7xl font-bold text-primary tracking-tight" data-id="element-149">
                11.999
              </span>
              <span className="text-xl font-bold text-secondary mt-auto mb-2" data-id="element-150">
                ARS
              </span>
            </div>

            <div className="w-full max-w-md mx-auto bg-warm rounded-2xl p-6 mb-8 text-left border border-border" data-id="element-151">
              <h3 className="font-bold text-primary mb-4 text-center" data-id="element-152">
                ¿Qué incluye tu acceso hoy?
              </h3>
              <ul className="space-y-3" data-id="element-153">
                {['Acceso inmediato al sistema completo', 'Formato digital (PDF) para cualquier dispositivo', 'BONUS 1: Planner Glow Up 30 días (GRATIS)', 'BONUS 2: Recetario Glow Drinks (GRATIS)', 'Actualización del contenido sin costo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-154">
                    <div className="bg-green-100 p-1 rounded-full shrink-0 mt-0.5" data-id="element-155">
                      <Check className="w-3 h-3 text-green-600 font-bold" data-id="element-156" />
                    </div>
                    <span className="text-secondary text-sm md:text-base" data-id="element-157">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <CTAButton text="¡Sí, quiero aprovechar la oferta!" className="w-full md:w-auto md:px-12 py-5 text-xl mb-8" data-id="element-158" />

            {/* Guarantee Box */}
            <div className="flex flex-col md:flex-row items-center gap-6 bg-cream p-6 rounded-xl border border-border max-w-2xl w-full text-left" data-id="element-159">
              <div className="bg-white p-4 rounded-full shadow-sm shrink-0" data-id="element-160">
                <ShieldCheck className="w-10 h-10 text-cta" data-id="element-161" />
              </div>
              <div data-id="element-162">
                <h4 className="font-bold text-primary text-lg mb-1" data-id="element-163">
                  Garantía de 7 Días
                </h4>
                <p className="text-sm text-secondary" data-id="element-164">
                  Probalo sin riesgo. Si no sentís más enfoque, energía o no
                  lográs empezar a cambiar tus hábitos, podés pedir la
                  devolución total de tu dinero. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}